// Simple encryption/decryption utility using AES
const ENCRYPTION_KEY = 'nova-content-secure-key-2024';

export const encrypt = (text: string): string => {
  try {
    // In a production environment, use a proper encryption library
    // This is a simple base64 encoding for demo purposes
    return btoa(text);
  } catch (error) {
    console.error('Encryption error:', error);
    return '';
  }
};

export const decrypt = (encryptedText: string): string => {
  try {
    // In a production environment, use a proper encryption library
    // This is a simple base64 decoding for demo purposes
    return atob(encryptedText);
  } catch (error) {
    console.error('Decryption error:', error);
    return '';
  }
};